'use client'

import Link from 'next/link'
import SafeImage from './SafeImage'
import { products } from '@/data/homepage'

export default function ProductsSection() {
  return (
    <section
      className="py-10 md:py-12 relative"
      style={{ background: 'linear-gradient(-45deg, #01124d 0%, #014b64 100%)' }}
    >
      <div className="container mx-auto px-4 max-w-6xl relative z-10">
        <div className="text-center mb-8">
          <div className="text-[#fdba74] font-semibold text-[11px] md:text-xs uppercase tracking-wider mb-1.5">
            Akustik Ses Yalıtım Malzemelerimiz
          </div>
          <h2 className="text-2xl md:text-3xl font-bold text-white">Akustik Panel Ürünlerimiz</h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4 mb-4">
          {products.map((product) => (
            <Link key={product.href} href={product.href} className="group block mb-3">
              <div
                className="relative overflow-hidden bg-white/5"
                style={{ aspectRatio: '1/1', borderRadius: 4 }}
              >
                <div
                  className="absolute inset-0 m-[6px] md:m-[8px] overflow-hidden"
                  style={{
                    borderRadius: '50%',
                    border: '2px solid rgba(255,255,255,0.2)',
                  }}
                >
                  <SafeImage
                    src={product.image}
                    alt={product.name}
                    fill
                    sizes="(max-width: 768px) 50vw, 25vw"
                    className="object-cover group-hover:scale-110 transition-transform duration-300"
                  />
                </div>
                <div
                  className="absolute inset-0 flex flex-col items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-10 px-3 text-center"
                  style={{ backgroundColor: 'rgba(247, 148, 29, 0.9)' }}
                >
                  <div className="text-white font-bold uppercase text-[11px] md:text-xs mb-1.5 leading-snug">
                    {product.name}
                  </div>
                  <div className="text-white text-[10px] underline uppercase tracking-wide">
                    ÜRÜNÜ GÖRÜNTÜLE
                  </div>
                </div>
              </div>
              <div className="mt-2 text-center text-white text-[11px] md:text-xs font-medium uppercase tracking-wide leading-snug">
                {product.name}
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  )
}
